import {
    BOOKINGREQUEST_LIST,
    BOOKINGREQUEST_PAGINATION,
    BOOKINGREQUEST_SUMMARY,
} from './constant';

export const initStateFeed = {
    bookingRequestList: [],
    pagination: {},
    summary: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case BOOKINGREQUEST_LIST: {
            return {
                ...state,
                bookingRequestList: action.payload,
            };
        }
        case BOOKINGREQUEST_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case BOOKINGREQUEST_SUMMARY: {
            return {
                ...state,
                summary: action.payload,
            };
        }
        default:
            return state;
    }
};
